import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Pdfexport from './Pdfexport';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function SimpleExpansionPanel(props) {
  //console.log(props.list.report);
  let name = props.list.report[0].templateName;
  // let by =props.list.report[0].By;
  // let date = props.list.report[0].date;
  // let inspection=
  // console.log(name);
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(true);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
   

    <div className={classes.root}>
      {props.list.report.map((value, index) => {
        return (
          <ExpansionPanel
            expanded
            onChange={handleChange("panel1")}
            className="custompanel"
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="col s12">
                <div className="row">
                  <div className="col s6">
                    <span className="headingList">Overview </span>
                  </div>
                  <div className="col s6 right-align">
                    <span className="headingList">0%</span>
                  </div>
                </div>
              </div>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
              <div className="col s12 border-main">
                <div className="row">
                  <div className="col s12 First-view">
                    <div className="col s11 tempImage">
                      <img
                        src="./images/report_logo.png"
                        className="image-fluid"
                        style={{ maxWidth: "12.5em", maxHeight: "12.5em" }}
                      />
                    </div>
                    <div className="col s12  ">
                      <h5 className="left-align">
                        <b>{value.templateName}</b>
                      </h5>
                    </div>
                    <div className="col s12  ">
                      <h6 className="left-align question-ans">
                        {value.date} / {value.By}
                      </h6>
                    </div>

                    <div className="col s12  ">
                      <div className="row Score ">
                        <div className="col s4 scoreborder ">
                          <h6 className="question-ans">Inspection score</h6>
                          <h6 className="report-percent">
                            <b>{value.InspectionScore}%</b>
                          </h6>
                        </div>
                        <div className="col s4 scoreborder ">
                          <h6 className="question-ans">Failed item</h6>
                          <h6 className="report-percent">
                            <b>{value.FailedItem}</b>
                          </h6>
                        </div>
                        <div className="col s4  scoreborder-1 ">
                          <h6 className="question-ans">Created actions</h6>
                          <h6 className="report-percent">
                            <b>{value.Created}</b>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ExpansionPanelDetails>
            {value.OverviewQuestion.map((detail, i) => {
              return (
                <ExpansionPanelDetails>
                  <div className="col s12 inner-details">
                    <div className="Inner-text">
                      <h6>{detail.questions}</h6>
                      <h6 className="question-ans">{detail.answer} </h6>
                    </div>
                  </div>
                </ExpansionPanelDetails>
              );
            })}

            {value.templateList.map((templist, j) => {
              return (
                <ExpansionPanel className="custompanel">
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <div className="col s12">
                      <div className="row">
                        <div className="col s6">
                          <span className="headingList">{templist.name}</span>
                        </div>
                        <div className="col s6 right-align">
                          <span className="headingList">
                            {templist.completionpercentage}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </ExpansionPanelSummary>

                  {templist.InnerList.map((inner, u) => {
                    return (
                      <ExpansionPanel className="custompanel">
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <div className="col s12">
                            <div className="row">
                              <div className="col s6">
                                <span className="headingList">
                                  {inner.name}{" "}
                                </span>
                              </div>
                              <div className="col s6 right-align">
                                <span className="headingList">0%</span>
                              </div>
                            </div>
                          </div>
                        </ExpansionPanelSummary>
                        {inner.Questions.map((ques, h) => {
                          return (
                            <ExpansionPanelDetails>
                              <div className="col s12 inner-details">
                                <div className="Inner-text">
                                  <h6>{ques.question}</h6>
                                  <h6 className="question-ans">Unanswered </h6>
                                </div>
                              </div>
                            </ExpansionPanelDetails>
                          );
                        })}
                      </ExpansionPanel>
                    );
                  })}
                </ExpansionPanel>
              );
            })}
          </ExpansionPanel>
        );
      })}
    </div>
  );
}
